import React from 'react';

const TermsOfService = () => {
	return (
		<div className="min-h-screen bg-zinc-900 py-16 px-4 sm:px-6 lg:px-8">
			<div className="max-w-4xl mx-auto">
				<h1 className="text-3xl font-bold text-white mb-8">Terms of Service</h1>

				<div className="space-y-8 text-slate-300">
					<section>
						<p className="mb-4 italic">Last Updated: December 1, 2024</p>
						<p className="mb-4">
							Please read these Terms of Service ("Terms") carefully before using Recovery House Portal.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
						<p className="mb-4">
							By using Recovery House Portal, you agree to these Terms of Service and applicable laws and regulations.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">2. Service Description</h2>
						<p className="mb-4">
							Recovery House Portal provides software services for recovery house operations. Our platform allows you to:
						</p>
						<ul className="list-disc pl-6 space-y-2 mb-4">
							<li>Manage and track resident data</li>
							<li>Monitor recovery progress</li>
							<li>Track organization analytical data</li>
							<li>Payment system to easily track resident payments and invoices</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">3. User Accounts</h2>
						<p className="mb-4">When using our service:</p>
						<ul className="list-disc pl-6 space-y-2 mb-4">
							<li>You must provide a valid email address</li>
							<li>You are responsible for maintaining password security</li>
							<li>You agree to notify us of unauthorized account use</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">4. Acceptable Use</h2>
						<p className="mb-4">You agree not to:</p>
						<ul className="list-disc pl-6 space-y-2 mb-4">
							<li>Use the service for any illegal purpose</li>
							<li>Attempt to access other users' accounts</li>
							<li>Upload malicious code or content</li>
							<li>Interfere with the proper working of the service</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">5. Termination</h2>
						<p className="mb-4">
							We reserve the right to suspend or terminate your access to the service for violations of these Terms or for any other reason at our discretion.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">6. Changes to Terms</h2>
						<p className="mb-4">
							We may update these Terms from time to time. Continued use of the service after changes means you accept the new Terms.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">7. Contact Us</h2>
						<p className="mb-4">
							For questions about these Terms, please contact us at{' '}
							<a href="mailto:recoveryhouseplatform@gmail.com" className="text-blue-400 hover:text-blue-300">
								recoveryhouseplatform@gmail.com
							</a>
						</p>
					</section>

					<section className="mt-8 pt-8 border-t border-zinc-700">
						<p className="text-sm text-slate-400">
							By using Recovery House Portal, you acknowledge that you have read and agree to these Terms of Service.
						</p>
					</section>
				</div>
			</div>
		</div>
	);
};

export default TermsOfService;